import { useTranslation } from 'react-i18next';
import { useMutation } from '@tanstack/react-query';
import { Button, Tooltip } from 'antd';
import { ViewIcon } from '@/assets/icons';
import { DownloadDocuments } from '@/components/download';
import { useNotify } from '@/hooks';
import { API } from '@/services/api.service';

/**
 * View / download for the HR document of one leave period — the same calls
 * and download menu as the HR documents table.
 */
export default function LeaveDocumentActions({ documentId }) {
  const { t } = useTranslation(['menus']);
  const notification = useNotify();

  const { mutate: viewPdf, isPending } = useMutation({
    mutationFn: () => API.documents.viewDocument(documentId),
    onError: (error) => {
      notification.error({ message: error?.message || 'Error' });
    },
  });

  return (
    <div className="flex gap-1.5">
      <Tooltip title={t('view')}>
        <Button
          className="h-8 w-8"
          icon={<ViewIcon />}
          loading={isPending}
          onClick={() => viewPdf()}
        />
      </Tooltip>
      <DownloadDocuments className="h-8 w-8" documentId={documentId} />
    </div>
  );
}
